<div class="documents-header mt-2 mb-5">
  <h5 class="font-weight-bold mb-0">{{ 'ProjectsDashboard.summary.documents.title' | translate }}</h5>

  <app-button
    (onClick)="createEntryWithAllDocumentTypes()"
    [config]="{
      size: ButtonSize.LARGE,
      type: ButtonTypes.NEW_PRIMARY_BLUE,
      text: ('ProjectsDashboard.summary.documents.add' | translate),
      prependSrc: './assets/img/ic-plus-add.svg'
    }"
  />
</div>

<div class="documents-card">
  <div class="documents-columns">
    @for (group of documentGroups(); track group.boxName) {
      <div class="documents-column">
        <div class="documents-column__header">
          <div class="documents-actions">
            <new-toggle-checkbox-v2
              [label]="'ProjectsDashboard.summary.documents.showEmpty' | translate"
              [ngModel]="isGroupExpanded(group.boxName)"
              (onValueChange)="toggleGroupVisibility(group.boxName, $event)"
            />
          </div>
        </div>

        <div class="documents-group" [attr.data-document-group]="group.boxName">
          <div class="documents-group__divider">
            <span>{{ group.title | translate }}</span>
          </div>

          <div class="documents-group__info">
            {{ group.description | translate }}
          </div>
        </div>

        <div class="documents-sections">
          @if (!group.hasDocuments) {
            <div class="documents-empty-state">
              {{ 'ProjectsDashboard.summary.documents.emptyState' | translate }}
            </div>
          } @else {
            @for (section of group.sections; track section.type) {
              <div
                class="documents-section"
                [attr.data-document-section]="group.boxName + '-' + section.type"
              >
                <div class="documents-section__header">
                  <button
                    type="button"
                    class="documents-section__header-toggle"
                    (click)="toggleSectionVisibility(group.boxName, section.type)"
                  >
                    <div class="documents-section__title">
                      <svg-icon
                        class="documents-section__arrow"
                        [class.documents-section__arrow--opened]="
                          isSectionExpanded(group.boxName, section.type)
                        "
                        src="./assets/img/ic-arrow-down-black.svg"
                      />

                      {{ section.translation | translate: section.translationParams }}
                    </div>
                  </button>

                  <button
                    type="button"
                    class="documents-section__add"
                    (click)="createEntryForSection(group.boxName, section.type)"
                  >
                    <svg-icon src="./assets/img/ic-plus-add.svg" />
                  </button>
                </div>

                @if (isSectionExpanded(group.boxName, section.type)) {
                  <div class="documents-items">
                    @for (item of section.items; track item.id) {
                      <div class="documents-item">
                        <div
                          class="documents-item__header"
                          [attr.data-document-item]="item.id"
                          [class.documents-item__header--expanded]="isItemExpanded(item.id)"
                          (click)="toggleItemVisibility(item.id)"
                        >
                          <div class="documents-item__toggle">
                            <div class="documents-item__title">
                              <svg-icon
                                class="documents-item__arrow"
                                [class.documents-item__arrow--opened]="isItemExpanded(item.id)"
                                src="./assets/img/ic-arrow-down-black.svg"
                              />

                              {{ item.name }}
                            </div>
                          </div>

                          <div class="documents-item__meta">
                            <span>{{ item.created | dateTimeFormat }}</span>

                            <button
                              type="button"
                              class="documents-item__icon-btn"
                              (click)="$event.stopPropagation(); editEntry(item.id)"
                            >
                              <svg-icon class="documents-item__icon" src="./assets/img/ic-edit-v2.svg" />
                            </button>

                            <button
                              type="button"
                              class="documents-item__icon-btn"
                              [disabled]="isDeleting(item.id)"
                              (click)="$event.stopPropagation(); confirmDelete(item.entry)"
                            >
                              <svg-icon class="documents-item__icon" src="/assets/img/ic-trash-red-v2.svg" />
                            </button>
                          </div>
                        </div>

                        @if (isItemExpanded(item.id)) {
                          <div class="documents-item__content">
                            <div class="documents-item__description quill-custom-img-size">
                              <div
                                class="documents-item__description-content value ql-editor"
                                [innerHTML]="item.description"
                              ></div>
                            </div>

                            @if (item.previewAttachments.length) {
                              <div
                                class="documents-item__attachments-list"
                                [class.documents-item__attachments-list--without-description]="
                                  !item.description
                                "
                              >
                                @for (
                                  attachment of item.previewAttachments;
                                  track attachmentTrackBy($index, attachment)
                                ) {
                                  <div class="documents-item__attachment-row">
                                    @if (attachment.isImage || attachment.isPdf) {
                                      <button
                                        type="button"
                                        class="documents-item__attachment-link"
                                        (click)="triggerAttachmentPreview($event, item.id, attachment.id)"
                                      >
                                        @if (attachment.isImage) {
                                          <img
                                            class="documents-item__attachment-row-thumb"
                                            [src]="attachment.file | authFile"
                                            [alt]="attachment.name"
                                          />
                                        } @else {
                                          <svg-icon
                                            class="documents-item__attachment-row-icon"
                                            [src]="'./assets/img/' + attachment.icon"
                                          />
                                        }

                                        <span class="documents-item__attachment-row-name">
                                          {{ attachment.name }}
                                        </span>
                                      </button>

                                      <a
                                        draggable="false"
                                        class="documents-item__attachment-preview-anchor"
                                        [href]="attachment.file | authFile"
                                        [attr.data-fancybox]="getGalleryId(item.id)"
                                        [attr.data-attachment-preview-id]="attachment.id"
                                        (click)="
                                          openAttachmentPreview($event, attachment, getGalleryId(item.id))
                                        "
                                      ></a>
                                    } @else {
                                      <div
                                        class="documents-item__attachment-link"
                                        filePreview
                                        [file]="attachment"
                                        [token]="getAttachmentToken()"
                                      >
                                        <svg-icon
                                          class="documents-item__attachment-row-icon"
                                          [src]="'./assets/img/' + attachment.icon"
                                        />

                                        <span class="documents-item__attachment-row-name">
                                          {{ attachment.name }}
                                        </span>
                                      </div>
                                    }

                                    <div class="documents-item__attachment-row-actions">
                                      <button
                                        type="button"
                                        class="documents-item__attachment-row-action"
                                        [disabled]="isAttachmentDownloading(attachment.id)"
                                        (click)="downloadAttachment($event, attachment)"
                                      >
                                        <svg-icon src="./assets/img/download-blue-icon.svg" />
                                      </button>

                                      <button
                                        type="button"
                                        class="documents-item__attachment-row-action"
                                        (click)="onAttachmentEditClick($event, item.id, attachment)"
                                      >
                                        <svg-icon src="./assets/img/ic-edit-v2.svg" />
                                      </button>

                                      <button
                                        type="button"
                                        class="documents-item__attachment-row-action documents-item__attachment-row-action--delete"
                                        [disabled]="isAttachmentDeleting(attachment.id)"
                                        (click)="confirmDeleteAttachment($event, item.id, attachment)"
                                      >
                                        <svg-icon src="/assets/img/ic-trash-red-v2.svg" />
                                      </button>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
